mutation EntityDocumentSingleDelete($input: EntityDocumentSingleDeleteInput!) {
  entityDocumentSingleDelete(input: $input) {
    entityDocument {
      __typename
      id
      _rowTimestamp
    }
    invoiceDocument {
      __typename
      id
      additionalStatusType {
        statusType
      }
      additionalInformationStatus
      _isApprovalDocumentsRequired
      _requiredApprovalDocuments
      _isStagedApprovalRequest
      _isDocumentsExist
      entityAppliedAmounts {
        appliedTotal
        usedTotal
      }
      controlTotalAmount
      _receiptsTotal
      invoiceDistributions(
        orderBy: [_CREATED_DATE_ASC, ACCOUNT_REFERENCE_ASC]
      ) {
        aggregates {
          sum {
            distributionAmount
          }
        }
        nodes {
          id
          _createdDate
          _isDeletable
          _isUpdatable
          _rowTimestamp
          accountReference
          additionalDescription
          distributionAmount
          businessUnitId
          departmentId
          productionIncentiveId
          projectReference
          purchaseOrderReference
          documentFileDistributionId
          poEntityDocumentId
          isPoCharge
          statusTypeId
          setReference
          tax1099T4TypeId
          referenceCode1
          referenceCode2
          referenceCode3
          referenceCode4
          referenceCode5
          _ff1Name
          _ff2Name
          _ff3Name
          _ff4Name
          statusExplanation
        }
      }
    }
    paymentDocument {
      id
      _isApprovalDocumentsRequired
      _requiredApprovalDocuments
      _isDocumentsExist
    }
    batchTransactionDocument {
      id
      _isApprovalDocumentsRequired
      _requiredApprovalDocuments
    }
  }
}
